import { gsap, Power4 } from 'gsap'
import { showTimelinePopup } from './timeline-popup'
import { showAudioTimelinePopup } from '../popup/audio-timeline-popup'

let isAnimating = false
let popupOpener = null

function startPopupOpenAnimation(clickedObject)
{
  isAnimating = true
  popupOpener = clickedObject

  let options = getPopupAnimationOptions(clickedObject)

  let screenWidth = $(window).width()
  let screenHeight = $(window).height()

  let rect = clickedObject[0].getBoundingClientRect()
  let top = rect.top / screenHeight * 100
  let bottom = rect.bottom / screenHeight * 100
  let left = rect.left / screenWidth * 100
  let right = rect.right / screenWidth * 100

  /* tlx tly trx rty brx bry blx bly */
  let tlx = left + '%'
  let tly = top + '%'

  let blx = left + '%'
  let bly = bottom + '%'

  let brx = right + '%'
  let bry = bottom + '%'

  let trx = right + '%'
  let rty = top + '%'

  let clipPath = tlx + ' ' + tly + ', ' + blx + ' ' + bly + ', ' + brx + ' ' + bry + ', ' + trx + ' ' + rty


  $('.popup-open-animation').show()


  gsap.fromTo('.popup-open-animation',
    {clipPath: "polygon("+clipPath+")", opacity: options.opacityFrom},
    {
            clipPath: "polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%)",
            ease: options.ease,
            duration: 0.4,
            opacity: options.opacityTo,
            onComplete: onCompleteActions,
            onCompleteParams: [clickedObject]
    },
    0.2)

  $('.popup-open-animation').attr('data-animate-out', clipPath)

}

function closePopupOpenAnimation()
{
  if(popupOpener) {
    $('.popup-open-animation').show()
    let animateOutClipPath = $('.popup-open-animation').attr('data-animate-out')
    let options = getPopupAnimationOptions(popupOpener)

    gsap.fromTo('.popup-open-animation',
      {clipPath: "polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%)", opacity: options.opacityTo},
      {
        clipPath: "polygon("+animateOutClipPath+")",
        ease: options.ease,
        duration: 0.4,
        opacity: options.opacityFrom,
        onComplete: hideAnimationPopup,
      },
      0.2)
  }

}

function hideAnimationPopup()
{
  $('.popup-open-animation').hide()
}

function getPopupAnimationOptions(clickedObject)
{
  let opacityValue = 0.8
  let opacityFromValue = 0
  let easeValue = Power4.easeIn
  if(clickedObject.hasClass('timeline-element-description')) {
    opacityValue = 1
    opacityFromValue = 1
  }
  if(clickedObject.hasClass('grid-item__item-img')) {
    easeValue = 'none'
  }

  return { opacityFrom: opacityFromValue, opacityTo: opacityValue, ease: easeValue}
}

function onCompleteActions(clickedObject)
{
  if(clickedObject.hasClass('audio-element')) {
    showAudioTimelinePopup()
    $('.popup-open-animation').fadeOut()
  } else if(clickedObject.hasClass('timeline-element-description')) {
    showTimelinePopup()
    $('.popup-open-animation').fadeOut()
  } else if(clickedObject.hasClass('vdieo-el-img-c')) {
    $('.popup-open-animation').hide()
    $('.js-video-popup').addClass('open')
  }


}

export { startPopupOpenAnimation, closePopupOpenAnimation }